module.exports = new __parcel__URL__("requisiteconfession.939de409.png").toString();